import React, { useContext, useEffect, useState } from "react";
import InputRegister from "../../../../blocks/ui/InputRegister";
import SelectInputWithSearch from "../../../../blocks/ui/SelectInputWithSearch";
import { IoMdAdd } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import { Layout } from "./Layout";
import courseCategories from '../../../../../data/courseCategories.json'
import { validateEducationInput } from '../../../../../utils/validator'
import SelectInput from "../../../../blocks/ui/SelectInput";
import { mode } from '../../../../../data/dropdownOptions'
import { DContext } from "../../../../../context/Datacontext";
import { createEducation } from "../../../../services/Candidate/Profile/Education.js/createEducation";
import { updateEducation } from "../../../../services/Candidate/Profile/Education.js/updateEducation";
import { deleteEducation } from "../../../../services/Candidate/Profile/Education.js/deleteEducation";
import { useLocation, useNavigate } from "react-router-dom";


const makeEmptySkill = () => ({
    institutionName: "",
    courseCategory: "",
    courseType: "",
    courseName: "",
    periodFrom: ["", "", ""],
    periodTo: ["", "", ""],
    mode: "",
    isOngoing: false,
    grade: {
        type: "",
        value: ""
    },
    location: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    description: ""
});

export const Education = ({ candidate, fetchCandidateData }) => {
    const { BeURL, formatPeriod, currentUser, showAlert } = useContext(DContext)
    const [education, setEducation] = useState([]);
    const [topInput, setTopInput] = useState(makeEmptySkill());
    const [editingCardId, setEditingCardId] = useState(null);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [qualificationOptions, setQualificationOptions] = useState(courseCategories.courseCategories);
    const [courseTypeOptions, setCourseTypeOptions] = useState([]);
    const [courseNameOptions, setCourseNameOptions] = useState([]);
    const navigate = useNavigate()

    // fetch the query:;

    const location = useLocation()
    const queryFetch = new URLSearchParams(location.search)
    const reverse = queryFetch.get('inverse') === "true"
    const previous = location.state?.from || '/account'
    const active = location.state?.active || 'Overview'


    useEffect(() => {
        fetchCandidateData()
    }, [])

    const mandatory = {
        courseName: true,
        courseCategory: true,
        courseType: true,
        city: false,
        mode: false,
        grade: { type: false, value: false },
        periodFrom: false,
        periodTo: !topInput.isOngoing,
        "grade.type": false,
        "grade.value": false
    };

    useEffect(() => {
        if (Array.isArray(candidate?.educations)) {
            setEducation(candidate?.educations);
        }
    }, [candidate?.educations]);


    const handleTopFieldChange = (field, value) => {
        setTopInput(prev => {
            const updated = { ...prev };

            if (field.includes(".")) {
                const [parent, child] = field.split(".");
                updated[parent] = { ...prev[parent], [child]: value };
            } else {
                updated[field] = value;
            }
            return updated;
        });

        setTouched(prev => ({ ...prev, [field]: true }));
        setErrors(prev => ({ ...prev, [field]: undefined }));


        if (field === "courseCategory") {
            const selectedCat = qualificationOptions.find(cat => cat.value === value);
            setCourseTypeOptions(selectedCat ? selectedCat.types : []);
            setCourseNameOptions([]);
            setTopInput(prev => ({ ...prev, courseType: "", courseName: "" }));
        }

        if (field === "courseType") {
            const selectedType = courseTypeOptions.find(type => type.value === value);
            setCourseNameOptions(selectedType ? selectedType.courses : []);
            setTopInput(prev => ({ ...prev, courseName: "" }));
        }

        if (field === "periodFrom") setErrors(prev => ({ ...prev, periodFromYear: undefined }));
        if (field === "periodTo") setErrors(prev => ({ ...prev, periodToYear: undefined }));
    };

    useEffect(() => {
        if (!validateEducationInput(topInput, setErrors)) return;
    }, [topInput])

    const handleTopClear = () => {
        setTopInput(makeEmptySkill());
        setErrors({});
        setTouched({});
        setEditingCardId(null);
    };

    const handleTopAdd = () => {
        setTouched(mandatory);
        if (!validateEducationInput(topInput, setErrors)) return;
        if (!BeURL || Object.keys(topInput).length === 0) {
            showAlert("Please fill all required fields and check server URL");
            return;
        }
        createEducation({ BeURL, education: [topInput], setEducation, handleTopClear, candidateId: candidate._id, showAlert })
    };

    const handleTopUpdate = (id) => {
        setTouched(mandatory);
        if (!validateEducationInput(topInput, setErrors)) return;
        setEducation(prev =>
            prev.map(c => (c.id === editingCardId ? { ...c, ...topInput, id: c.id } : c))
        );
        updateEducation({ BeURL, id, education: [topInput], handleTopClear, candidateId: candidate._id, showAlert })
    };


    const handleCardDelete = (id) => {
        if (!id) {
            showAlert("Education ID missing!");
            return;
        }
        const confirmDelete = window.confirm("Are you sure you want to delete this education?");
        if (confirmDelete) {
            setEducation(prev => prev.filter(edu => edu._id !== id))
            deleteEducation({ BeURL, id, handleTopClear, candidateId: candidate._id, showAlert })
        } else {
            console.error("Delete cancelled");
        }
    };

    const handleCardEdit = (idx) => {
        const card = education[idx];
        if (!card) return;

        const normalizePeriod = (isoDateStr) => {
            if (!isoDateStr) return ["", "", ""];
            const date = new Date(isoDateStr);
            const year = date.getFullYear().toString();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            return [year, month === "01" && day === "01" ? "" : month, month === "01" && day === "01" ? "" : day];
        };

        const edu = {
            ...card,
            periodFrom: normalizePeriod(card.startDate),
            periodTo: normalizePeriod(card.endDate),
            year: normalizePeriod(card.startDate)[0],
            month: normalizePeriod(card.startDate)[1],
            date: normalizePeriod(card.startDate)[2],
            grade: {
                type: card?.grade?.type?.toLowerCase() || "", // match options.value
                value: card?.grade?.value || "",
            },
        };

        setTopInput({ ...edu });

        // Set dependent options for edit mode
        const selectedCategory = qualificationOptions.find(cat => cat.value === card.courseCategory);
        setCourseTypeOptions(selectedCategory ? selectedCategory.types : []);
        const selectedType = selectedCategory?.types?.find(t => t.value === card.courseType);
        setCourseNameOptions(selectedType ? selectedType.courses : []);

        setEditingCardId(card._id);
        setErrors({});
        setTouched({});
    };

    const handleSubmit = () => {


        if (education && education.length > 0) {
            if (reverse)
                navigate(previous, { state: { active } })

            else {
                const confirmed = window.confirm("Are you sure you want to go to experience?");
                if (!confirmed) return;
                navigate(`/update-account/experience?candidateId=${candidate?._id}`);
            }

        } else {
            showAlert("Please add at least one education detail before proceeding.");
        }
    };


    return (
        <Layout candidate={candidate}>
            <section className="max-w-7xl mx-auto  w-full py-4 mb-20">
                <div className="py-4">
                    {/* Top Input Panel */}
                    <div className="border-2 p-[8px] px-[10px] rounded-2xl  bg-white shadow-sm ">
                        {/* Inputs Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-3 md:gap-1 mt-[12px]">
                            <SelectInputWithSearch
                                label="Qualification"
                                mandatory
                                value={topInput.courseCategory}
                                onChange={e => handleTopFieldChange("courseCategory", e.target.value)}
                                options={qualificationOptions}
                                placeholder="Qualification"
                                className={`w-full ${errors.courseCategory && touched.courseCategory ? "border-red-500" : ""}`}
                                error={errors.courseCategory && touched.courseCategory ? errors.courseCategory : ""}
                                border={true}
                            />
                            <SelectInputWithSearch
                                label="Course / Degree name"
                                mandatory
                                value={topInput.courseType}
                                onChange={e => handleTopFieldChange("courseType", e.target.value)}
                                options={courseTypeOptions}
                                placeholder="Course / Degree name"
                                className={`w-full ${errors.courseType && touched.courseType ? "border-red-500" : ""}`}
                                error={errors.courseType && touched.courseType ? errors.courseType : ""}
                                border={true}
                            />
                            <SelectInputWithSearch
                                label="Specialization"
                                mandatory={topInput.courseCategory !== 'secondary_school_10th' && true}
                                value={topInput.courseName}
                                onChange={e => handleTopFieldChange("courseName", e.target.value)}
                                options={courseNameOptions}
                                placeholder="Specialization"
                                className={`w-full ${errors.courseName && touched.courseName ? "border-red-500" : ""}`}
                                border={true}
                                error={errors.courseName && touched.courseName ? errors.courseName : ""}

                            />

                            <InputRegister
                                label="Institution / University Name"
                                // mandatory
                                value={topInput.institutionName}
                                onChange={e => handleTopFieldChange("institutionName", e.target.value)}
                                placeholder="Institution / University Name"
                                type="text"
                                className={`w-full ${errors.institutionName && touched.institutionName ? "border-red-500" : ""}`}
                                error={errors.institutionName && touched.institutionName ? errors.institutionName : ""}
                                border={true}
                            />

                            <SelectInput
                                label="Grade Type"
                                // mandatory
                                value={topInput.grade.type}
                                onChange={(e) => handleTopFieldChange("grade.type", e.target.value.toLowerCase())}
                                options={[
                                    { label: "CGPA", value: "cgpa" },
                                    { label: "Percentage", value: "percentage" }
                                ]}
                                placeholder="Grade Type"
                                error={errors["grade.type"] && touched["grade.type"] ? errors["grade.type"] : ""}
                                className={"w-full"}
                                border={true}
                            />

                            <InputRegister
                                label="Grade / Score / CGPA"
                                // mandatory
                                value={topInput.grade.value}
                                onChange={(e) => {
                                    let val = e.target.value;

                                    if (topInput.grade.type === "cgpa") {
                                        if (!/^\d{0,2}(\.\d{0,1})?$/.test(val)) return;
                                        const num = parseFloat(val);
                                        if (!isNaN(num) && num > 10) return;
                                    } else if (topInput.grade.type === "percentage") {
                                        if (!/^\d{0,3}$/.test(val)) return;
                                        const num = parseFloat(val);
                                        if (!isNaN(num) && num > 100) return;
                                    }

                                    handleTopFieldChange("grade.value", val);
                                }}
                                placeholder={
                                    topInput.grade.type === "cgpa"
                                        ? "CGPA (0-10, 1 decimal)"
                                        : topInput.grade.type === "percentage"
                                            ? "Percentage (0-100)"
                                            : "Grade / Score / CGPA"
                                }
                                type="text"
                                error={errors["grade.value"] && touched["grade.value"] ? errors["grade.value"] : ""}
                                className={"w-full"}
                                border={true}
                            />

                            <SelectInput
                                label="Mode of Study"
                                // mandatory
                                value={topInput.mode}
                                onChange={(e) => handleTopFieldChange("mode", e.target.value.toLowerCase())}
                                options={mode}
                                placeholder="Mode of Study"
                                error={errors.mode && touched.mode ? errors.mode : ""}
                                className={"w-full"}
                                border={true}
                            />
                            <InputRegister
                                label={"City"}
                                value={topInput.city}
                                // mandatory
                                onChange={(e) => handleTopFieldChange("city", e.target.value)}
                                placeholder="City"
                                type="text"
                                className={"w-full"}
                                error={errors.city && touched.city ? errors.city : ""}
                                border={true}
                            />
                            <InputRegister
                                label={"State"}
                                value={topInput.state}
                                onChange={(e) => handleTopFieldChange("state", e.target.value)}
                                placeholder="state"
                                type="text"
                                className={"w-full"}
                                border={true}
                            />
                            <InputRegister
                                label={"Country"}
                                value={topInput.country}
                                onChange={(e) => handleTopFieldChange("country", e.target.value)}
                                placeholder="country"
                                type="text"
                                className={"w-full"}
                                border={true}
                            />
                            <InputRegister
                                label={"Pin Code"}
                                value={topInput.zipCode}
                                onChange={(e) => handleTopFieldChange("zipCode", e.target.value)}
                                placeholder="pin-code"
                                type="text"
                                className={"w-full"}
                                error={errors.zipCode || ""}
                                border={true}
                            />
                        </div>
                        {/* Start Date */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:gap-2 gap-12">
                            <div>
                                <label className="text-sm text-slate-600">Year of Start</label>
                                <div className="flex gap-3 mt-2">
                                    <div>
                                        <select
                                            value={topInput.periodFrom[0]}
                                            onChange={e => {
                                                const newDate = [...topInput.periodFrom];
                                                newDate[0] = e.target.value;
                                                handleTopFieldChange("periodFrom", newDate);
                                            }}
                                            className={`w-20 h-11 text-center border rounded-lg ${errors.periodFromYear && touched.periodFromYear ? "border-red-500" : "border-gray-300"}`}
                                        >
                                            <option value="">YYYY</option>
                                            {Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i).map(y => (
                                                <option key={y} value={y}>{y}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Month Dropdown */}
                                    {
                                        topInput.periodFrom[0] &&
                                        <div>
                                            <select
                                                value={topInput.periodFrom[1] || ""}
                                                onChange={(e) => {
                                                    const newDate = [...topInput.periodFrom];
                                                    newDate[1] = e.target.value;
                                                    handleTopFieldChange("periodFrom", newDate);
                                                }}
                                                className="w-16 h-11 text-center border rounded-lg"
                                            >
                                                <option value="">MM</option>
                                                {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                                    <option key={month} value={month.toString().padStart(2, "0")}>
                                                        {month.toString().padStart(2, "0")}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    }
                                    {/* Day Dropdown */}
                                    {topInput.periodFrom[1] &&
                                        <div>
                                            <select
                                                value={topInput.periodFrom[2]}
                                                onChange={(e) => {
                                                    const newDate = [...topInput.periodFrom];
                                                    newDate[2] = e.target.value;
                                                    handleTopFieldChange("periodFrom", newDate);
                                                }}
                                                className="w-16 h-11 text-center border rounded-lg"
                                            >
                                                <option value="">DD</option>
                                                {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                    <option key={day} value={day.toString().padStart(2, "0")}>
                                                        {day.toString().padStart(2, "0")}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    }
                                </div>
                                {errors.periodFrom && touched.periodFrom &&
                                    <p className="text-red-500 text-xs">{errors.periodFrom}</p>
                                }
                            </div>
                            <div>
                                <div className="flex justify-between">
                                    {!topInput.isOngoing && <label className="text-sm text-slate-600">Year of Passing</label>}

                                </div>
                                {
                                    !topInput.isOngoing && (
                                        <div className="flex gap-4 mt-2">
                                            <div>
                                                {/* <select
                                                    value={topInput.periodTo[0]}
                                                    disabled={topInput.isOngoing}
                                                    onChange={e => {
                                                        const newDate = [...topInput.periodTo];
                                                        newDate[0] = e.target.value;
                                                        handleTopFieldChange("periodTo", newDate);
                                                    }}
                                                    className={`w-20 h-11 text-center border rounded-lg ${!topInput.isOngoing
                                                        ? errors.periodToYear && touched.periodToYear
                                                            ? "border-red-500"
                                                            : "border-gray-300"
                                                        : ""
                                                        }`}
                                                >
                                                    <option value="">YYYY</option>
                                                    {Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i).map(y => (
                                                        <option key={y} value={y} disabled={y < Number(topInput.periodFrom[0])}>{y}</option>
                                                    ))}
                                                </select> */}

                                                <select
                                                    value={topInput.periodTo[0]}
                                                    disabled={topInput.isOngoing}
                                                    onChange={e => {
                                                        const newDate = [...topInput.periodTo];
                                                        newDate[0] = e.target.value;
                                                        handleTopFieldChange("periodTo", newDate);
                                                    }}
                                                    className={`w-20 h-11 text-center border rounded-lg ${!topInput.isOngoing
                                                            ? errors.periodToYear && touched.periodToYear
                                                                ? "border-red-500"
                                                                : "border-gray-300"
                                                            : ""
                                                        }`}
                                                >
                                                    <option value="">YYYY</option>

                                                    {(() => {
                                                        const currentYear = new Date().getFullYear();
                                                        const years = [];

                                                        // 20 years past → 30 years future
                                                        for (let i = -20; i <= 100; i++) {
                                                            years.push(currentYear + i);
                                                        }

                                                        return years.map(y => (
                                                            <option
                                                                key={y}
                                                                value={y}
                                                                disabled={Number(y) < Number(topInput.periodFrom[0])}
                                                            >
                                                                {y}
                                                            </option>
                                                        ));
                                                    })()}
                                                </select>

                                            </div>

                                            {/* Month Dropdown */}
                                            {topInput.periodTo[0] &&
                                                <div>
                                                    <select
                                                        value={topInput.periodTo[1] || ""}
                                                        onChange={(e) => {
                                                            const newDate = [...topInput.periodTo];
                                                            newDate[1] = e.target.value;
                                                            handleTopFieldChange("periodTo", newDate);
                                                        }}
                                                        className="w-16 h-11 text-center border rounded-lg"
                                                    >
                                                        <option value="">MM</option>
                                                        {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                                            <option key={month} value={month.toString().padStart(2, "0")}
                                                                disabled={(Number(topInput.periodTo[0]) === Number(topInput.periodFrom[0])) && month < Number(topInput.periodFrom[1])}>
                                                                {month.toString().padStart(2, "0")}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                            }
                                            {/* Day Dropdown */}
                                            {topInput.periodTo[1] &&
                                                <div>
                                                    <select
                                                        value={topInput.periodTo[2]}
                                                        onChange={(e) => {
                                                            const newDate = [...topInput.periodTo];
                                                            newDate[2] = e.target.value;
                                                            handleTopFieldChange("periodTo", newDate);
                                                        }}
                                                        className="w-16 h-11 text-center border rounded-lg"
                                                    >
                                                        <option value="">DD</option>
                                                        {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                            <option key={day} value={day.toString().padStart(2, "0")}
                                                                disabled={(Number(topInput.periodTo[1]) === Number(topInput.periodFrom[1])) && day < Number(topInput.periodFrom[2])}>
                                                                {day.toString().padStart(2, "0")}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                            }

                                        </div>
                                    )
                                }

                                {errors.periodTo && touched.periodTo &&
                                    <p className="text-red-500 text-xs flow">{errors.periodTo}</p>
                                }

                            </div>
                            <div className="flex items-center gap-2 px-6">
                                <input
                                    type="checkbox"
                                    checked={topInput.isOngoing}
                                    onChange={e => handleTopFieldChange("isOngoing", e.target.checked)}
                                    className=" h-4 w-4 text-blue-600 border-gray-300 rounded"
                                />
                                <span className={`text-gray-400 text-sm ${topInput.isOngoing ? "text-primary-500 font-medium" : "text-slate-600"}`}>Currently pursuing</span>
                            </div>
                        </div>
                        {/* Description */}
                        <div className="flex flex-col gap-1 md:col-span-3 mt-[8px]">
                            <label className="text-sm text-slate-600 font-semibold">Description</label>
                            <textarea
                                value={topInput.description}
                                onChange={e => handleTopFieldChange("description", e.target.value)}
                                placeholder="Enter description..."
                                className="w-full p-2 placeholder:text-sm border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                                rows={4}
                            />
                        </div>

                        <div className="flex items-center gap-2 justify-end mt-[8px]">
                            {editingCardId ? (
                                <div className="flex gap-3">
                                    <button title="clear" type="button" onClick={handleTopClear} className="px-3 py-1 rounded underline  font-semibold text-primary-500 flex items-center justify-center text-base">
                                        Clear
                                    </button>
                                    <button title="update" type="button" onClick={() => handleTopUpdate(editingCardId)} className=" px-1 w-[70px] md:w-[80px] rounded-lg bg-primary-400 font-semibold text-white flex items-center justify-center shadow-md">
                                        Update
                                    </button>
                                </div>
                            ) : (
                                <div className="flex gap-2">
                                    <button onClick={handleTopClear} type="button" className="px-3 py-1 rounded underline  font-semibold text-primary-500 flex items-center justify-center ">
                                        Clear
                                    </button>
                                    <button title="add" type="button" onClick={handleTopAdd} className="px-1 w-[70px] md:w-[80px] rounded-lg bg-primary-400 text-white font-semibold flex items-center justify-center shadow-md">
                                           Add
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                    {/* education List */}
                    <div className="mt-3 space-y-4 bg-white rounded-2xl px-4 py-3 w-full">
                        <p>
                            Education <span>({education.length})</span>
                        </p>
                        {education.length === 0 && (
                            <div className="text-sm text-gray-400 italic">
                                No education details added yet. Enter the candidate’s education above.
                            </div>
                        )}

                        {/* scroll wrapper with buttons */}
                        <div className="relative">
                            {/* Scrollable cards */}
                            <div
                                id="expScroll"
                                className="flex gap-4 overflow-x-auto px-6 py-2"
                            >
                                {education.map((card, idx) => (
                                    <div
                                        key={idx}
                                        className="bg-white shoadow-lg rounded-lg flex-shrink-0 shadow-md p-4 w-full sm:w-[48%] md:w-[30%]"
                                    >
                                        {/* Header: Job Title + Actions */}
                                        <div className="flex justify-between items-start mb-2">
                                            <div>
                                                <p className="text-xs text-slate-400">Specialization</p>
                                                <p className="font-medium text-slate-800 capitalize">
                                                    {(card?.courseType) || "-"}
                                                </p>
                                            </div>
                                            <div className="flex gap-2">
                                                <button
                                                    type="button"
                                                    onClick={() => handleCardEdit(idx)}
                                                    className="text-slate-600 p-1 hover:text-blue-600"
                                                    title="Edit"
                                                >
                                                    <FiEdit2 />
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => handleCardDelete(card._id)}
                                                    className="text-red-500 p-1 hover:text-red-700"
                                                    title="Delete"
                                                >
                                                    <MdDeleteOutline />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Company Name */}
                                        <div className="mt-2">
                                            <p className="text-xs text-slate-400">Course</p>
                                            <p className="text-slate-700 capitalize">{card.courseCategory || "-"}</p>
                                        </div>

                                        {/* Date */}
                                        <div className="flex justify-between">
                                            <div className="mt-2">
                                                <p className="text-xs text-slate-400">Period from</p>
                                                <p className="text-slate-700">
                                                    {(() => {
                                                        const p = formatPeriod(card.startDate);
                                                        return `${p.date ? p.date + " " : ""}${p.month ? p.month + " " : ""}${p.year || "-"}`;
                                                    })()}
                                                </p>
                                            </div>
                                            <div className="mt-2">
                                                <p className="text-xs text-slate-400">Period to</p>
                                                <p className="text-slate-700">
                                                    {(() => {
                                                        const p = formatPeriod(card.endDate);
                                                        return `${p.date ? p.date + " " : ""}${p.month ? p.month + " " : ""}${p.year || "-"}`;
                                                    })()}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="mt-2">
                                            <p className="text-xs text-slate-400">Description</p>
                                            <p className="text-slate-700 capitalize line-clamp-2">{card.description || "-"}</p>
                                        </div>
                                    </div>
                                ))}

                            </div>

                            <div className="flex justify-end mt-1 items-center gap-2">
                                {/* hint text */}
                                <p className="text-[10px] text-slate-400 italic">
                                    Use ← and → buttons to scroll
                                </p>
                                {/* Left button */}
                                <button
                                    onClick={() => {
                                        document.getElementById("expScroll").scrollBy({ left: -200, behavior: "smooth" });
                                    }}
                                    className=" bg-white shadow rounded-full p-1 text-xs"
                                >
                                    ◀
                                </button>
                                {/* Right button */}
                                <button
                                    onClick={() => {
                                        document.getElementById("expScroll").scrollBy({ left: 200, behavior: "smooth" });
                                    }}
                                    className="  bg-white shadow rounded-full p-1 text-xs"
                                >
                                    ▶
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full">
                    {/* Back Button */}
                    <button onClick={() => navigate(`/update-account/profilesummery?candidateId=${candidate?._id}`)}
                        className="w-full sm:w-auto border border-primary-500 text-primary-500 px-4 py-2 rounded-xl font-medium  transition text-center">
                        Previous
                    </button>

                    {/* Complete Button */}
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={education.length === 0}
                        className={`w-full sm:w-auto ${education.length > 0 ? "bg-[#2C25C4]" : "bg-slate-400"} text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center`}
                    >
                        {reverse ? 'Update' : 'Next'}
                    </button>
                </div>
            </section>
        </Layout>
    );
};


















